import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { QUERY_KEY } from '@constants';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import { type GetViewupSnsAccountsRes, getViewupSnsAccounts } from './mapper';

export const useGetViewupSnsAccounts = (params?: QueryParam<GetViewupSnsAccountsRes>) => {
  const { accessToken } = useTokenStore();

  return useSDQuery<GetViewupSnsAccountsRes>({
    ...params?.options,
    enabled: params?.options?.enabled ?? !!accessToken,
    queryKey: [QUERY_KEY.SNS_ACCOUNTS_VIEWUP],
    queryFn: () => getViewupSnsAccounts(),
  });
};
